import Customer from '@outdoor-voices/ui/dist/utils/Customer';
import jwtDecode from 'jwt-decode';
import { VISITOR_ID } from '../../config/constants';
import { getAccessToken } from '../../apps/customers/utils';
import Cookies from 'js-cookie';

var getVisitorId = function getVisitorId() {
  try {
    var customer = new Customer();
    return customer.getGA() || VISITOR_ID;
  } catch (exc) {
    console.error(exc);
    return VISITOR_ID;
  }
};

var getDataLayer = function getDataLayer() {
  var _gre = [];
  window._gre = _gre;
  return _gre;
};

var getUserInfo = function getUserInfo() {
  // 'userInfo': {
  //   'userId': 'abc@example.com',
  //   'ipAddress': '8.8.8.8',
  //   'userAgent': 'Mozilla/5.0',
  //   'directUserRequest': true
  // },
  var token = getAccessToken();

  if (!token) {
    return false;
  }

  var _jwtDecode = jwtDecode(token),
      username = _jwtDecode.username;

  var userAgent = window.navigator.userAgent;
  return {
    userId: username,
    userAgent: userAgent
  };
};

var getAttributionToken = function getAttributionToken() {
  var urlParams = new URLSearchParams(window.location.search);
  var token = urlParams.get('rtoken') || Cookies.get('ov-rtoken');

  if (token) {
    var expires = 1 / 48;
    Cookies.set('ov-rtoken', token, {
      expires: expires
    });
    return token;
  }

  return false;
};

var getProductDetail = function getProductDetail(items) {
  return items.map(function (_ref) {
    var id = _ref.id,
        quantity = _ref.quantity;
    return {
      product: {
        id: String(id)
      },
      quantity: quantity
    };
  });
};

var pushEvent = function pushEvent(eventType, event) {
  var _gre = getDataLayer(); // Credentials for project.


  _gre.push(['apiKey', 'AIzaSyCe1YolJESCPfDK6zxMg6wNbOteXY_M4cs']);

  _gre.push(['projectId', '362818442591']);

  _gre.push(['locationId', 'global']);

  _gre.push(['catalogId', 'default_catalog']); // https://cloud.google.com/retail/docs/reference/rest/v2/projects.locations.catalogs.userEvents


  event.eventType = eventType;
  event.visitorId = getVisitorId();
  var userInfo = getUserInfo();
  var attributionToken = getAttributionToken();

  if (userInfo) {
    event.userInfo = userInfo;
  }

  if (attributionToken) {
    event.attributionToken = attributionToken;
  } // console.info(eventType, JSON.stringify(event));


  _gre.push(['logEvent', event]);

  if (window.cloud_retail) {
    window.cloud_retail.logEvent(_gre);
  } else {
    console.error('window.cloud_retail undefined');
  }
};

export var retailAddToCart = function retailAddToCart(_ref2) {
  var cartToken = _ref2.cartToken,
      variantId = _ref2.variantId;
  var event = {
    cartId: cartToken,
    productDetails: getProductDetail([{
      id: variantId,
      quantity: 1
    }])
  };
  pushEvent('add-to-cart', event);
};
export var retailCartPageView = function retailCartPageView(_ref3) {
  var cartToken = _ref3.cartToken,
      items = _ref3.items;
  var event = {
    cartId: cartToken,
    productDetails: getProductDetail(items)
  };
  pushEvent('shopping-cart-page-view', event);
};
export var retailCategoryPageView = function retailCategoryPageView(_ref4) {
  var collectionTitle = _ref4.collectionTitle;
  var event = {
    pageCategories: [collectionTitle]
  };
  pushEvent('category-page-view', event);
};
export var retailDetailPageView = function retailDetailPageView(_ref5) {
  var variantId = _ref5.variantId;
  var event = {
    productDetails: [{
      product: {
        id: String(variantId)
      }
    }]
  };
  pushEvent('detail-page-view', event);
};
export var retailHomePageView = function retailHomePageView() {
  var event = {};
  pushEvent('home-page-view', event);
};
export var retailPurchaseComplete = function retailPurchaseComplete(_ref6) {
  var id = _ref6.id,
      revenue = _ref6.revenue,
      items = _ref6.items;
  // https://cloud.google.com/retail/docs/reference/rest/v2/projects.locations.catalogs.userEvents#PurchaseTransaction
  var event = {
    productDetails: getProductDetail(items),
    purchaseTransaction: {
      id: id,
      revenue: revenue,
      currencyCode: 'USD'
    }
  };
  pushEvent('purchase-complete', event);
};